import { render, staticRenderFns } from "./InvoiceTypeSh.vue?vue&type=template&id=153770b6"
import script from "./InvoiceTypeSh.vue?vue&type=script&lang=js"
export * from "./InvoiceTypeSh.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTypeSh.vue?vue&type=style&index=0&id=153770b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports